exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".infos[data-v-716837d8]{font-size:11px;margin:15px}p[data-v-716837d8]{margin-bottom:7px!important}", "", {"version":3,"sources":["/app/src/components/clients/FormClient.vue"],"names":[],"mappings":"AACA,wBACE,eAAgB,AAChB,WAAa,CACd,AACD,mBACE,2BAA8B,CAC/B","file":"FormClient.vue","sourcesContent":["\n.infos[data-v-716837d8] {\n  font-size: 11px;\n  margin: 15px;\n}\np[data-v-716837d8] {\n  margin-bottom: 7px !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-716837d8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/clients/FormClient.vue
// module id = 480
// module chunks = 6